import { Link } from "react-router-dom";

const LOGO_URL = "/images/logo.png";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-white/5 bg-[#050B17]"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
                <div>
                    <Link to="/" className="flex items-center">
                        <img
                            src={LOGO_URL}
                            alt="MechXpress"
                            className="h-16 sm:h-20 w-auto rounded-xl"
                        />
                    </Link>
                    <p className="mt-4 text-sm text-[#A1B0CC] leading-relaxed max-w-xs">
                        The mechanic-first network. Connecting independent
                        mechanics to customers — and to each other.
                    </p>
                </div>
                <div className="text-sm">
                    <div className="text-xs uppercase tracking-wider text-[#10B981] font-bold mb-4">
                        Platform
                    </div>
                    <ul className="space-y-3 text-[#A1B0CC]">
                        <li>
                            <Link
                                to="/"
                                className="hover:text-white transition-colors"
                            >
                                For Customers
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/for-mechanics"
                                className="hover:text-white transition-colors"
                            >
                                For Mechanics
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className="text-sm">
                    <div className="text-xs uppercase tracking-wider text-[#10B981] font-bold mb-4">
                        Service Area
                    </div>
                    <p className="text-[#A1B0CC] leading-relaxed">
                        Launching in Washington DC, Maryland, and Virginia —
                        the DMV area.
                    </p>
                </div>
            </div>
            <div className="border-t border-white/5">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#6B7280]">
                    <span>
                        © {new Date().getFullYear()} MechXpress. All rights
                        reserved.
                    </span>
                    <span>Built for the DMV.</span>
                </div>
            </div>
        </footer>
    );
}
